import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-sanction-condition',
    templateUrl: './sanction-condition.component.html',
    styleUrls: ['./sanction-condition.component.scss'],
    standalone: false
})
export class SanctionConditionComponent implements OnInit {
@Input() data;
  constructor() { }

  ngOnInit(): void {
  }

}
